// extracted by mini-css-extract-plugin
export var arrows = "_67-6";
export var decrementer = "_67-a";
export var disabled = "_67-4";
export var error = "_67-1";
export var hiddenText = "_67-b";
export var incrementer = "_67-9";
export var input = "_67-8";
export var inputWrapper = "_67-0";
export var leadingIcon = "_67-c";
export var readonly = "_67-3";
export var regular = "_67-7";
export var small = "_67-5";
export var warning = "_67-2";